<template>
  <ContentSection>
    <!-- TITLE -->
    <AnimatedContainer v-if="data.heading || data.text">
      <HeadingAndText :heading="data.heading" :text="data.text" />
    </AnimatedContainer>

    <FormBuilder
      :form-blueprint="data.form"
      :text-checkbox-conditions="textCheckboxConditions"
      :send-button-text="data.send_button_text"
      :message-success="data.message_success"
      :message-error="data.message_error"
    />
  </ContentSection>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object, required: true,
  },
})

const textCheckboxConditions = computed(() => {
  if (!props.data.show_checkbox_conditions) {
    return ''
  }

  return props.data.text_checkbox_conditions
})
</script>
